import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * A safer redirect component that uses window.location as a fallback
 * if the React Router navigation fails
 */
const SafeRedirect = ({ to, replace = false }) => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      // Try to use React Router's navigate function
      navigate(to, { replace });
    } catch (error) {
      console.error('Navigation error:', error);
      
      // Fallback to using window.location if React Router navigation fails
      if (replace) {
        // Use hash-based navigation for compatibility with HashRouter
        window.location.replace(window.location.origin + '/#' + to);
      } else {
        window.location.href = window.location.origin + '/#' + to;
      }
    }
  }, [navigate, to, replace]);

  // Return null as this is just a navigation component
  return null;
};

export default SafeRedirect; 